import {
    INSPECTION_PHOTO_STEP_SCREEN_SHOW,
    INSPECTION_PHOTO_STEP_SCREEN_HIDE,
    FULLSCREEN_CAMERA_SHOW,
    FULLSCREEN_CAMERA_HIDE,
    LOADING_SCREEN_SHOW,
    LOADING_SCREEN_HIDE,
    MAINTENANCE_SCREEN_SHOW,
    MAINTENANCE_SCREEN_HIDE,
    SELF_INSPECTION_SCREEN_SHOW,
    SELF_INSPECTION_SCREEN_HIDE,
    IVERI_SUCCESS_SCREEN_SHOW,
    IVERI_SUCCESS_SCREEN_HIDE,
    FNOL_TAKE_PHOTO_SCREEN_SHOW,
    FNOL_TAKE_PHOTO_SCREEN_HIDE,
    CLAIMSV2_TAKE_PHOTO_SCREEN_SHOW,
    CLAIMSV2_TAKE_PHOTO_SCREEN_HIDE,
    QUOTE_LOADING_SCREEN_SHOW,
    QUOTE_LOADING_SCREEN_HIDE,
} from './../constants/constants';

export const showLoadingScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: LOADING_SCREEN_SHOW
        })
    }
}

export const hideLoadingScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: LOADING_SCREEN_HIDE
        })
    }
}

export const showPhotoStepsScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: INSPECTION_PHOTO_STEP_SCREEN_SHOW
        })
    }
}

export const hidePhotoStepsScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: INSPECTION_PHOTO_STEP_SCREEN_HIDE
        })
    }
}

export const showSelfInspectStepsScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: SELF_INSPECTION_SCREEN_SHOW
        })
    }
}

export const hideSelfInspectStepsScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: SELF_INSPECTION_SCREEN_HIDE
        })
    }
}

export const showFNOLStepsScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: FNOL_TAKE_PHOTO_SCREEN_SHOW
        })
    }
}

export const hideFNOLStepsScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: FNOL_TAKE_PHOTO_SCREEN_HIDE
        })
    }
}

export const showClaimsV2StepsScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: CLAIMSV2_TAKE_PHOTO_SCREEN_SHOW
        })
    }
}

export const hideClaimsV2StepsScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: CLAIMSV2_TAKE_PHOTO_SCREEN_HIDE
        })
    }
}

export const showFullscreenCamera = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: FULLSCREEN_CAMERA_SHOW
        })
    }
}

export const hideFullscreenCamera = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: FULLSCREEN_CAMERA_HIDE
        })
    }
}

export const showMaintenanceScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: MAINTENANCE_SCREEN_SHOW
        })
    }
}

export const hideMaintenanceScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: MAINTENANCE_SCREEN_HIDE
        })
    }
}

export const showIveriScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: IVERI_SUCCESS_SCREEN_SHOW
        })
    }
}

export const hideIveriScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: IVERI_SUCCESS_SCREEN_HIDE
        })
    }
}

export const showQuoteLoadingScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: QUOTE_LOADING_SCREEN_SHOW
        })
    }
}

export const hideQuoteLoadingScreen = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: QUOTE_LOADING_SCREEN_HIDE
        })
    }
}